import React from 'react';
import { Breadcrumbs, Link as MUILink, Typography, Stack, Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import breadcrumbDot from '../../../assets/images/SVG/placeholder Fill 1.svg';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';

const font = '"Poppins", sans-serif';

const CustomBreadcrumbs = ({ items = [], sx = {} }) => {
    const theme = useTheme();
    const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1, ...sx }}>
            <Breadcrumbs
                aria-label="breadcrumb"
                sx={{
                    '& .MuiBreadcrumbs-ol': {
                        flexWrap: 'nowrap',
                        alignItems: 'center',
                    },
                    '& .MuiBreadcrumbs-li': {
                        display: 'flex',
                        alignItems: 'center',
                        lineHeight: 1,
                    },
                    '& .MuiBreadcrumbs-separator': {
                        display: 'flex',
                        alignItems: 'center',
                        mx: 0.5,
                    }
                }}
                separator={
                    <Box
                        component="img"
                        src={breadcrumbDot}
                        alt=""
                        sx={{
                            width: 15,
                            height: 15,
                            display: 'block',
                            pointerEvents: 'none'
                        }}
                    />
                }
            >
                {items.map((item, index) => {
                    if (isSmDown && item.hideOnMobile) {
                        return null;
                    }

                    const isLast = index === items.length - 1;
                    const isLink = item.href || item.onClick;
                    const isFirstItem = index === 0;

                    if (isLink) {
                        return (
                            <MUILink
                                key={index}
                                href={item.href}
                                onClick={item.onClick}
                                sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    color: '#e95d2d',
                                    fontWeight: 500,
                                    cursor: 'pointer',
                                    fontFamily: font,
                                    fontSize: 14,
                                    lineHeight: '20px',
                                    textDecoration: 'none',
                                    ...item.sx
                                }}
                                underline="hover"
                            >
                                {isFirstItem && (
                                    <HomeRoundedIcon
                                        sx={{
                                            mr: 0.5,
                                            fontSize: 18,
                                            display: 'block',
                                        }}
                                    />
                                )}
                                <span style={{ display: 'inline-flex', alignItems: 'center' }}>{item.label}</span>
                            </MUILink>
                        );
                    }

                    return (
                        <Typography
                            key={index}
                            color={isLast ? 'text.primary' : 'text.secondary'}
                            sx={{
                                fontFamily: font,
                                fontSize: 14,
                                fontWeight: isLast ? 600 : 400,
                                lineHeight: '20px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                ...item.sx
                            }}
                        >
                            {item.label}
                        </Typography>
                    );
                })}
            </Breadcrumbs>
        </Stack>
    );
};

export default CustomBreadcrumbs;
